module.exports = __webpack_public_path__ + "img/dualfuel.c96797d.svg";